import React, { useCallback, useState } from "react";
import client from "@culturehq/client";
import { Form, Modal, SubmitButton, Success, TextField } from "@culturehq/components";

import { t, Trans } from "app/utils";

import PageHeader from "components/display/PageHeader";
import ErrorMessage from "./ErrorMessage";
import ChqModal from "./ChqModal";

const STATUS = { default: 0, success: 1, error: 2 };

const Flag = ({ action, children, options }) => {
  const [status, setStatus] = useState(STATUS.DEFAULT);

  const onSubmit = useCallback(
    async ({ message }) => {
      setStatus(STATUS.default);

      try {
        await client[action]({ ...options, message });
        setStatus(STATUS.success);
      } catch (error) {
        setStatus(STATUS.error);
      }
    },
    [setStatus, action, options]
  );

  return (
    <ChqModal trigger={children} width="narrow">
      <Modal.Heading>
        <Trans>What is wrong with this content?</Trans>
      </Modal.Heading>
      <Modal.Body>
        <PageHeader title={t("Submit Flagged Content")}>
          <Trans>
            Include a note for the admins on why you thought this content was
            inappropriate.
          </Trans>
        </PageHeader>

        {status === STATUS.error && (
          <ErrorMessage error={t("Error flagging content")} />
        )}

        {status === STATUS.success && (
          <Success>
            <Trans>Feedback Submitted</Trans>
          </Success>
        )}

        {status !== STATUS.success && (
          <Form onSubmit={onSubmit}>
            <TextField name="message" required>
              <Trans>Add a Note</Trans>
            </TextField>
            <SubmitButton fillParent />
          </Form>
        )}
      </Modal.Body>
    </ChqModal>
  );
};

export default Flag;
